import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/shared/Validators/custom-validators';

@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.css']
})
export class LocationsComponent implements OnInit {
  mailingAddressForm: FormGroup
  billingAddressForm: FormGroup
  title = "Locations"
  sameAsMailingAddress:any=false
  providerSites:any=[]
  constructor(private formBuilder: FormBuilder) {
this.initBillingAddressForms();
this.initMailingAddressForms();

  }
  initMailingAddressForms() {
    this.mailingAddressForm = this.formBuilder.group({
      "MailingAddressLine1": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "MailingAddressLine2": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "City": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "State": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "Zipcode": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator, , Validators.minLength(5)])],
      "Contact": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "Fax": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])]
    });

  }
  initBillingAddressForms() {
    this.billingAddressForm = this.formBuilder.group({
      "MailingAddressLine1": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "MailingAddressLine2": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "City": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "State": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "Zipcode": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator, , Validators.minLength(5)])],
      "Contact": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "Fax": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])]
    });

  }
  ngOnInit(): void {
  }
  changeSiteStatus(providerSiteId) {
   
 }
 submit(model:any,isValid:any){}
}
